import { render, staticRenderFns } from "./deletionRequest.vue?vue&type=template&id=1d4e6aa0&scoped=true"
import script from "./deletionRequest.vue?vue&type=script&lang=js"
export * from "./deletionRequest.vue?vue&type=script&lang=js"
import style0 from "./deletionRequest.vue?vue&type=style&index=0&id=1d4e6aa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4e6aa0",
  null
  
)

export default component.exports